/**
 * Lifecycle values the interface has to state out loud.
 *
 * These are fixed by the product concept, not configurable, and the server is
 * the authority on all of them — `config.lifecycle` in the API. They are
 * repeated here only because a sentence like "links last 15 minutes" has to be
 * rendered before any request is made, and a page that has to ask the server
 * how long a link lasts in order to say so would be worse.
 *
 * If one ever changes, it changes in the concept first, then in the API, then
 * here. They are not independent.
 */

/** Magic-link lifetime. Mirrors `config.lifecycle.loginTokenTtlSeconds`. */
export const LOGIN_LINK_TTL_MINUTES = 15;
